import { render, staticRenderFns } from "./BasePositionDirection.vue?vue&type=template&id=a96be42a&scoped=true"
import script from "./BasePositionDirection.vue?vue&type=script&lang=js"
export * from "./BasePositionDirection.vue?vue&type=script&lang=js"
import style0 from "./BasePositionDirection.vue?vue&type=style&index=0&id=a96be42a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96be42a",
  null
  
)

export default component.exports